import { defineStore } from 'pinia'

export const useBottomSheetStore = defineStore('bottomSheet', {
  state: () => ({
    isOpen: false,
    id: null as string | null,             // identifier for which sheet to open
    title: null as string | null,
    component: null as any,                // component to render inside
    componentProps: {} as Record<string, any>,
    bgColor: 'white' as 'white' | 'grey' | 'primary',
    siteLogo: true,
    showOnDesktop: true,
    disablePersistence: false,             // 👈 new: master switch to skip localStorage
  }),
  actions: {
    openSheet({
      id,
      title,
      component,
      props = {},
      options = {},
    }: {
      id: string
      title?: string
      component: any
      props?: object
      options?: {
        bgColor?: 'white' | 'grey' | 'primary'
        siteLogo?: boolean
        showOnDesktop?: boolean
        disablePersistence?: boolean       // 👈 support disablePersistence
      }
    }) {
      this.id = id
      this.title = title ?? null
      this.component = component
      this.componentProps = props
      this.bgColor = options.bgColor ?? 'white'
      this.siteLogo = options.siteLogo ?? true
      this.showOnDesktop = options.showOnDesktop ?? true
      this.disablePersistence = options.disablePersistence ?? false
      this.isOpen = true
    },
    closeSheet() {
      this.isOpen = false
      this.id = null
      this.title = null
      this.component = null
      this.componentProps = {}
      this.disablePersistence = false
    },
  },
})